export class ContactTitre {
  public id: number;
  public titre?: string;
  public codeLangueAutomatiqueId?: number;
  public typeSociete?: boolean;
  public typePhysiqueHomme?: boolean;
  public typePhysiqueFemme?: boolean;
}
